import { render, staticRenderFns } from "./ModuleModal.vue?vue&type=template&id=dc589632&scoped=true"
import script from "./ModuleModal.vue?vue&type=script&lang=js"
export * from "./ModuleModal.vue?vue&type=script&lang=js"
import style0 from "./ModuleModal.vue?vue&type=style&index=0&id=dc589632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc589632",
  null
  
)

export default component.exports